import React from 'react'
import { NavLink } from 'react-router-dom'

import UseCounts from '@connects/counts'
import PrivilegedContent from '@components/PrivilegedContent/PrivilegedContent'

import './MainNav.scss'

// var Links = links.map(({label, ...props}) => 
// 	<NavLink key={props.to} className="MainNav-link" activeClassName="current" {...props}>{label}</NavLink>
// )

const MainNavLink = ({children, ...props}) => 
	<NavLink className="MainNav-link" activeClassName="current" {...props}>{children}</NavLink> 

const PrivilegedNavLink = ({permissions, ...props}) => 
	<PrivilegedContent permissions={permissions}>
		<MainNavLink {...props} />
	</PrivilegedContent>

const isActiveRegex = (regex) => (match, location) => regex.test(location.pathname);

@UseCounts()
class MainNav extends React.Component {
	renderCount(key) {
		const count = this.props.countData[key];
		return count != null && count > 0 ? ` (${count})` : '';
	}
	render() {
		return (
			<nav className="MainNav">
				<MainNavLink to="/dashboard">Dashboard</MainNavLink>

				<PrivilegedNavLink 
					to='/candidates'
					permissions={['readOwn:candidate']}
					isActive={isActiveRegex(/^\/candidate/)}
				>
					Candidates{this.renderCount('candidate')}
				</PrivilegedNavLink>

				<PrivilegedNavLink 
					to='/clients'
					permissions={['readOwn:client']}
					isActive={isActiveRegex(/^\/client/)}
				>
					Clients
				</PrivilegedNavLink>

				<PrivilegedNavLink 
					to='/admins'
					permissions={['readAny:admin']}
					isActive={isActiveRegex(/^\/admin/)}
				>
					Consultants
				</PrivilegedNavLink>

				<PrivilegedNavLink 
					to='/jobs'
					permissions={['readOwn:job']}
					isActive={isActiveRegex(/^\/job/)}
				>
					Job Board{this.renderCount('job')}
				</PrivilegedNavLink>

				<PrivilegedNavLink 
					to='/timesheets'
					permissions={['readOwn:timesheet']}
					isActive={isActiveRegex(/^\/timesheet/)}
				>
					Timesheets{this.renderCount('timesheet')}
				</PrivilegedNavLink>

				<MainNavLink to='/logout'>Logout</MainNavLink>

			</nav>
		)
	}
}

export default MainNav


// WEBPACK FOOTER //
// ./src/components/MainNav/MainNav.jsx